export const serverUrl = {
    //baseURL: 'https://api.youdomain.com/adminApi/', // 正式环境
    //  baseURL: '/admin/',
    // baseURL:'http://10.10.0.79:8667/',
    //baseURL:'http://10.10.2.108:8667/',
    // baseURL: 'http://apitest.86122m.com/',
    baseURL: process.env.NODE_ENV === 'development'?'https://platform.iiasx.org.cn/api':'/api',
    // baseURL: process.env.NODE_ENV === 'development'?'https://platadmin.iiasx.org.cn/api':'/api',
    // baseURL: process.env.NODE_ENV === 'development'?'http://10.10.0.191:8008':'/api',
    // uploadUrl: 'http://10.10.0.79:8667/api/file/uploadObjectOSS',
		uploadUrl: 'https://api.86122m.com/api/file/uploadObjectOSS',
    imgUrl: 'https://mzmpic.oss-cn-beijing.aliyuncs.com/',
}



// WEBPACK FOOTER //
// ./src/utils/server.js